import QuestionnaireTemplate from "components/pages/questions/questionnaire_template";

import { persistedQuestionnaire } from "utils/questionnaire";

import { useMounted } from "hooks/react";

export default function QuestionnaireTemplatePage(props) {
  useMounted(() => {
    const answeredCount = persistedQuestionnaire()?.answeredCount;
    if (!answeredCount) return;
  });

  return <QuestionnaireTemplate {...props} />;
}
